import React from 'react';

import AdaptivePageHeader from '@components/fw/AdaptiveElements/AdaptivePageHeader';

export const UserOperationInfoHeader = () => {
  return <AdaptivePageHeader title={'Дополнение информации операций'} />;
};
